import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from 'aurora-translations';
import styles from './styles';

function TextReview(props) {
  const { classes, values } = props;

  return (
    <Grid container spacing={3} className={classes.container}>
      {values.map(val => {
        // const currentIndex = index + 1;
        return (
          <Grid
            key={val.id}
            item
            xs={12}
            md={4}
            className={classNames(classes.gridItem, {
              //   [classes.border]: currentIndex % 3 === 2,
            })}
          >
            <div>
              <Typography variant='body1'>
                {messages[val.label.key]?.id ? (
                  <FormattedMessage {...messages[val.label.key]} values={val.label.values} />
                ) : (
                  val.label.key
                )}
              </Typography>
              <Typography variant='subtitle1'>{val.value}</Typography>
            </div>
          </Grid>
        );
      })}
    </Grid>
  );
}

TextReview.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.array.isRequired,
};

TextReview.defaultProps = {
  disabled: false,
};

export default withStyles(styles)(TextReview);
